import { FC, PropsWithChildren, useRef } from "react";
import filterRoutes, {
  getDomain,
  withRouteDomains,
  withRoutesRoles,
} from "./filter";

// import { ReactLocationDevtools } from 'react-location-devtools';
import { Router } from "react-location";
import _ from "lodash";
import location from "./location";
// import { useReactiveVar } from "@apollo/client";
import routes from "./routes";

// import { currentConfigVar } from "_graphql/cache/config";
// import { currentUserVar } from "_graphql/cache/auth";

;

const RoutesProvider: FC<PropsWithChildren> = ({ children }) => {
  // const currentTheme = useReactiveVar(currentConfigVar);
  // const currentUser = useReactiveVar(currentUserVar);
  return (
    <div className={""}>
      <Router
        location={location}
        routes={routes}
        filterRoutes={filterRoutes()}
      >
        {/* <ReactLocationDevtools initialIsOpen={false} /> */}
        {children}
      </Router>
    </div>
  );
};

export default RoutesProvider;
